import React from "react";
import { GiArchiveResearch } from "react-icons/gi";
import { IoDocumentOutline } from "react-icons/io5";
import { RiTeamLine } from "react-icons/ri";
import { TfiHelpAlt } from "react-icons/tfi";
import { TiDocumentAdd } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import "./category.scss";

const JournalCategories = ({ data }) => {

  const navigate = useNavigate();

  const goTo = (index) => {
    if (index === 2) {
      window.open(data.categoryLinks[index])
    }
    else {
      navigate(data.categoryLinks[index])
    }
  }

  return (
    <div className='category-container'>
      <h2>{data.title}</h2>

      <section className="category-list">
        {data.categories.map((category, index) => {
          return (
            <div className='category-item' key={index} 
              onClick={() => goTo(index)}>
              <div className='category-icon'>
                {index === 0 ? <GiArchiveResearch size={25}/> : null}
                {index === 1 ? <RiTeamLine size={25}/> : null}
                {index === 2 ? <TiDocumentAdd size={25}/> : null}
                {index === 3 ? <TfiHelpAlt size={25}/> : null}
                {index === 4 ? <IoDocumentOutline size={25}/> : null}
              </div>
              <div className='category-name'>
                {category}
              </div>
            </div>
          )
        })}
      </section>
    </div>
  )
}

export default JournalCategories;
